
export const options = {
    swipeToSlide: true,
    infinite: false,
    cssEase: 'ease',
    speed: 600
};

export const prevArrow = `
    <button class="slider__arrow slider__prev button--default" aria-label="Previous Slide">
        <svg class="icon icon--arrow" xmlns="http://www.w3.org/2000/svg" width="47" height="43" viewBox="0 0 47 43" style="transform: rotate(180deg)">
            <path d="m19.549 13.599 7.9 7.9-7.9 7.9" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" fill="none" />
        </svg>
    </button>`;
export const nextArrow = `
    <button class="slider__arrow slider__next button--default" aria-label="Next Slide">
        <svg class="icon icon--arrow" xmlns="http://www.w3.org/2000/svg" width="47" height="43" viewBox="0 0 47 43">
            <path d="m19.549 13.599 7.9 7.9-7.9 7.9" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" fill="none" />
        </svg>
    </button>`;